// Components==============
import { faMapMarkerAlt, faMapSigns } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { HomeContext } from 'screens/Home/Home';
import { buildingOptions, BuildingTypes, Colors } from 'screens/Login/Login';
import { getTilePosition } from 'utilities/getTilePosition';
import './WelcomeButton.module.scss';
// =========================

export default function WelcomeButton({
    avatarRef,
}: {
    avatarRef: React.RefObject<HTMLDivElement>;
}) {
    const { setWelcomeSequence, setCurrentTile, currentTile } = useContext(
        HomeContext
    );

    const user = useSelector((store: ReduxStore) => store.authentication?.user);

    function handleOpenSequence() {
        setWelcomeSequence((prev) =>
            prev === 'initial' ? 'welcome' : 'initial'
        );
    }

    function handlePositionToTile() {
        const destination = currentTile.ref;

        const { originX, originY } = getTilePosition(destination);
        setCurrentTile((prev) => ({ ...prev, originX, originY }));
    }
    function handlePostionToHome() {
        const destination = avatarRef;

        const { originX, originY } = getTilePosition(destination);
        setCurrentTile((prev) => ({ ...prev, originX, originY }));
    }

    const buildingType = user?.username?.split('_')[2] as BuildingTypes;
    const selectedColor = (user?.username?.split('_')[3] as Colors) || 'blue';

    const icon = buildingOptions.find(
        (option) => option.option === buildingType
    )?.icon;

    return (
        <div styleName="wrapper">
            <button type="button" onClick={handleOpenSequence}>
                <FontAwesomeIcon icon={faMapSigns} />
            </button>
            <button
                type="button"
                onClick={handlePostionToHome}
                styleName={selectedColor}
            >
                <FontAwesomeIcon icon={icon} />
            </button>
            <button
                type="button"
                onClick={handlePositionToTile}
                styleName="red"
            >
                <FontAwesomeIcon icon={faMapMarkerAlt} />
            </button>
        </div>
    );
}
